import mapProductHistoryCompany from './mapProductHistoryCompany';
import ProductHistoryCompanyChange from './ProductHistoryCompanyChange';

export interface RawProductHistoryCompanyChange {
	current: { name: string } | null;
	previous: { name: string } | null;
}

export default function mapProductHistoryCompanyChange(
	change: RawProductHistoryCompanyChange
): ProductHistoryCompanyChange {
	return new ProductHistoryCompanyChange(
		change.previous !== null ? mapProductHistoryCompany(change.previous) : null,
		change.current !== null ? mapProductHistoryCompany(change.current) : null
	);
}
